import React from 'react';
import ReactDOM from 'react-dom';
import {HashRouter} from "react-router-dom";
import {Provider} from 'react-redux';
import {MuiThemeProvider} from '@material-ui/core'
import App from './App';
import store from './redux/store';
import theme from './themes/theme';
import { StylesProvider, createGenerateClassName } from '@mui/styles';
import { ConfirmProvider } from 'material-ui-confirm';

const generateClassName = createGenerateClassName({
    productionPrefix: 'c',
});

ReactDOM.render(
    <React.StrictMode>
        <MuiThemeProvider theme={theme}>
            <Provider store={store}>
                <ConfirmProvider>
                    <HashRouter>
                        <StylesProvider generateClassName={generateClassName}><App/></StylesProvider>;
                    </HashRouter>
                </ConfirmProvider>
            </Provider>
        </MuiThemeProvider>
    </React.StrictMode>,
    document.getElementById('root')
);
